import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const containerStyle = css`
  padding: 24px 20px;
`;

export const contentWrapperStyle = css`
  margin-inline: auto;

  ${MEDIA_QUERY_FOR_PC} {
    width: 640px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
    min-width: 360px;
  }
`;

export const titleStyle = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 24px;
`;

export const informationStyle = css`
  background-color: #fff;
  border: 1px solid #d4d4d4;

  ${MEDIA_QUERY_FOR_PC} {
    padding-bottom: 24px;
  }
`;
